










import { Component, Vue } from 'vue-property-decorator';
import { Warning, OpenForm } from '@/pages/profile/components';
import { IMentoringEmptyTeams } from './types';

@Component({
  components: {
    Warning,
    OpenForm,
  },
})
export default class MentoringEmptyTeams
  extends Vue
  implements IMentoringEmptyTeams {
  click(): void {
    this.$emit('addRequest');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/emptyteams/MentoringEmptyTeams.vue